/* eslint-disable @nx/enforce-module-boundaries */
import { SearchIcon } from '@mybridge/icons/Search';
import {
  CloseButton,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
} from '@mybridge/ui';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useState } from 'react';
export const SearchExpand = ({isOpen, onToggle, value, onChange }) => {
  const [inputValue, setInputValue] = useState(value || '');
  const { t } = useTranslator();
  const handleChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    onChange?.(newValue);
  };

  return isOpen ? (
    <InputGroup maxW="300px" alignItems="center">
      <Input
        autoFocus
        placeholder={t('profileDetails.typeToSearch') || "Type to search..."}
        value={inputValue}
        onChange={handleChange}
        borderRadius="50px"
        padding={onToggle ? "15px 43px" : "15px 30px"}
        height="40px"
        border="1px solid #DDDDDD"
      />
      <InputRightElement>
        <CloseButton
        mb="20%"
          onClick={() => {
            setInputValue('');
            onChange?.('');
            onToggle(false);
          }}
        />
      </InputRightElement>
    </InputGroup>
  ) : (
    <IconButton
      variant="secondary"
      onClick={() => onToggle(true)} 
      borderRadius="full"
    >
      <SearchIcon />
    </IconButton>
  );
};